import React, { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { passValidator } from "../../../utils/formsValidation";
import FormInput from "../../../utils/FormInput";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { useDispatch } from "react-redux";
import { USER_CHANGE_PASS_URL } from "../../api/apiRoutes";
import useFacility from "../../../utils/hooks/useFacility";
import { USER_TOKEN } from "../../store/auth/authMiddleware";
import { setSuccessMessage } from "../../store/alerts/alertsActions";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";
import EAModal from "../shared/Modal/EAModal";
import EAAlert from "../shared/EAAlert";

type Inputs = {
  oldPassword: string;
  newPassword: string;
};

interface IProps {
  b2bPartner?: boolean;
}

const ChangePassword: React.FC<IProps> = ({ b2bPartner = false }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [formError, setFormError] = useState<string>("");
  const { post } = useApiRequest();
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const userToken = sessionStorage.getItem(USER_TOKEN);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const handleChangePassword: SubmitHandler<Inputs> = async (data) => {
    setFormError(""); // Clear previous errors
    const parsedUserToken = userToken ? JSON.parse(userToken).sessionToken : "";
    // const url = b2bPartner ? PARTNER_B2B_CHANGE_PASS_URL(facilityIds) : USER_CHANGE_PASS_URL(facilityIds);
    const url = USER_CHANGE_PASS_URL(facilityIds);
    const body = {
      oldpassword: data.oldPassword,
      password: data.newPassword,
      token: parsedUserToken,
    };
    const { isError, errorTable } = await post(url, body);

    if (!isError) {
      dispatch(setSuccessMessage(t("operacja_przebiegla_pomyslnie")));
      setOpen(false);
      setFormError("");
    } else {
      // Set local error instead of dispatching to Redux
      const errorMessage = errorTable && errorTable.length > 0 ? errorTable[0] : t("wystapil_blad");
      setFormError(errorMessage);
    }
  };

  const handleCloseModal = () => {
    setOpen(false);
    setFormError(""); // Clear errors when closing modal
  };

  return (
    <React.Fragment>
      <EAButton title={t("zmiana_hasla")} onClick={() => setOpen(true)} fullWidth variant="text" />

      {open && (
        <EAModal
          isOpen={open}
          onClose={handleCloseModal}
          title={t("zmiana_hasla")}
          // hideAcceptButton
          acceptButtonLabel={t("zmien")}
          onAccept={handleSubmit(handleChangePassword)}
        >
          <form onSubmit={handleSubmit(handleChangePassword)} style={{ width: "40vw" }}>
            <FormInput
              type={"password"}
              name={"oldPassword"}
              text={t("stare_haslo")}
              register={{ ...register("oldPassword", {}) }}
              errors={errors}
              isLabel
            />
            <FormInput
              type={"password"}
              name={"newPassword"}
              text={t("nowe_haslo")}
              register={{ ...register("newPassword", { ...passValidator(true) }) }}
              errors={errors}
              isLabel
            />

            {formError && (
              <div style={{ marginTop: "16px" }}>
                <EAAlert message={formError} type="error" />
              </div>
            )}
          </form>
        </EAModal>
      )}
    </React.Fragment>
  );
};

export default ChangePassword;
